import { Injectable } from '@angular/core';
import { PageFilter } from '@core/model/pagination/filter';
import { PageResult } from '@core/model/pagination/page-result';
import { strictMap } from '@core/utils/object-utils';
import { TicketStatusChange, TicketStatusChangeFilterInput, AddTicketStatusGQL, AddTicketAssigneeGQL, UpdateTicketStatusGQL, UpdatePrimaryAssigneeGQL, GetTicketStatusChangeByTicketIdsGQL, AddStatusWithNaotesGQL } from '@generated/queries';
import { Observable, firstValueFrom, map } from 'rxjs';
import { CreateTicketStatusChange, TicketsStatusChange, UpdateTicketPrimaryAssignee, UpdateTicketStatus, UpdateTicketStatusChange } from '../models/ticket-status-change';
import { plainToInstance } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class TicketStatusChangeService {

  icket$: Observable<PageResult<TicketStatusChange>>;
  pageFilter: PageFilter = {
    pageIndex: 0,
    activeIndex: 1,
    take: 10,
    search: '',
    state: '',
  };
  vmFilters: TicketStatusChangeFilterInput;

  constructor(
    private ticketStatusAdd:AddTicketStatusGQL,
    private ticketAssigneeAdd:AddTicketAssigneeGQL,
    private ticketStatusUpdate:UpdateTicketStatusGQL,
    private ticketPrimaryAssigneeUpdate:UpdatePrimaryAssigneeGQL,
    private ticketChangeStatusByIds: GetTicketStatusChangeByTicketIdsGQL,
    private ticketStatusChangeWithNotes: AddStatusWithNaotesGQL,
  ) { }


getTicketStatusChangeByTicketIds(ticketIds: string[]): Promise<TicketsStatusChange[]> {
    return firstValueFrom(
      this.ticketChangeStatusByIds
        .fetch({ ticketIds }, { fetchPolicy: 'network-only' })
        .pipe(
          map((x) =>
            plainToInstance(
              TicketsStatusChange,
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              x.data.supportTicket.ticketStatusChangeByTicketIds as any[]
            )
          )
        )
    );
  }

  addTicketStatus(model: TicketStatusChange): Promise<string> {
    return firstValueFrom(this.ticketStatusAdd
      .mutate({ model: strictMap(CreateTicketStatusChange, model) })
      .pipe(map((x) => x.data.supportTicket.ticketStatusChange.add)));
  }

  addTicketAssignee(model: TicketStatusChange): Promise<string> {
    return firstValueFrom(this.ticketAssigneeAdd
      .mutate({ model: strictMap(CreateTicketStatusChange, model) })
      .pipe(map((x) => x.data.supportTicket.ticketStatusChange.assignUser)));
  }

  updateTicketStatus(model: UpdateTicketStatus): Promise<string> {
    return firstValueFrom(this.ticketStatusUpdate
      .mutate({ model: strictMap(UpdateTicketStatus, model) })
      .pipe(map((x) => x.data.supportTicket.tickets.ticketStatus)));
  }

  updateTicketPrimaryAssignee(model: UpdateTicketPrimaryAssignee): Promise<string> {
      return firstValueFrom(this.ticketPrimaryAssigneeUpdate
        .mutate({ model: strictMap(UpdateTicketPrimaryAssignee, model) })
        .pipe(map((x) => x.data.supportTicket.ticketStatusChange.updatePrimaryAssignee)))
    }

  changeTicketStatusWithNotes(model: UpdateTicketStatusChange): Promise<string> {
    return firstValueFrom(this.ticketStatusChangeWithNotes
      .mutate({ model: strictMap(UpdateTicketStatusChange, model) })
      .pipe(map((x) => x.data.supportTicket.ticketStatusChange.changeStatusWithNotes)))
  }
}
